// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"8d3705c1","952":"e3ae8572"}[chunkId] + ".chunk.js";
};